<!-- ----------------------------------------------- -->
<template>
  <v-col
    v-bind:class="pcPanelModeClass"
    v-if="tmRainList.length !== 0 && tmRainList.tmRainDetailInfo.ofcCd"
  >
    <tm-rain-info></tm-rain-info>

    <template v-if="pcPanelMode" class="com-pc-card">
      <v-card class="com-pc-card">
        <v-row>
          <v-col>
            <tm-rain-curt></tm-rain-curt>
          </v-col>
          <v-col>
            <v-row class="com-pc-card-header">
              <div class="com-pc-card-title">
                {{ text.tab.graph }}
              </div>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <div v-if="tabIndex === 0" class="tm-list">
                  <!-- 拡大表示 -->
                  <tm-rain-graph-dlg
                    v-if="modalDiag"
                    @close="closeModal"
                    :isHour="timeMode"
                    :isExpansion="scalMode"
                    :isLegend="isLegendDisp"
                  ></tm-rain-graph-dlg>
                  <div @dblclick="openModal">
                    <tm-rain-graph
                      :isHour="timeMode"
                      :isExpansion="scalMode"
                      :isLegend="isLegendDisp"
                    ></tm-rain-graph>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="isDispContentsSwitch()">
              <v-col :sm="12" class="pa-2">
                <div class="float-right pt-1">
                  <v-btn
                    tile
                    depressed
                    small
                    class="graph-btn"
                    color="success"
                    :outlined="scalMode === true"
                    @click="scalMode = false"
                    >{{ text.btn.zoomout }}</v-btn
                  >
                  <v-btn
                    tile
                    depressed
                    small
                    class="graph-btn"
                    color="success"
                    :outlined="scalMode === false"
                    @click="scalMode = true"
                    >{{ text.btn.zoomin }}</v-btn
                  >
                  <v-btn
                    tile
                    depressed
                    small
                    class="graph-btn ml-2"
                    color="success"
                    :outlined="timeMode === false"
                    @click="timeMode = true"
                    >{{ text.btn.timehour }}</v-btn
                  >
                  <v-btn
                    tile
                    depressed
                    small
                    class="graph-btn"
                    color="success"
                    :outlined="timeMode === true"
                    @click="timeMode = false"
                    >{{ text.btn.time10 }}</v-btn
                  >
                  <v-btn
                    depressed
                    small
                    class="legend-btn"
                    color="orange"
                    dark
                    :outlined="!isLegendDisp"
                    @click="isLegendDisp = !isLegendDisp"
                  >
                    <v-icon>import_contacts</v-icon>
                    {{ text.btn.legend }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </template>

    <template v-if="!pcPanelMode" class="com-pc-card">
      <v-card class="com-pc-card">
        <v-col class="com-pc-card-contents pa-0">
          <v-row no-gutters class="vc-tab pb-1 justify-center">
            <v-btn
              class="vc-tab-btn"
              depressed
              :class="{ 'btn-on': tabIndex === 0 }"
              @click="tabIndex = 0"
              >{{ text.tab.graph }}</v-btn
            >
            <v-btn class="vc-tab-btn" depressed @click="openObs()"
              >{{ text.tab.obsInfo }}</v-btn
            >
          </v-row>
          <v-col class="tm-box-list pa-1 pt-2">
            <div v-if="tabIndex === 0" class="tm-list">
              <!-- 拡大表示 -->
              <tm-rain-graph-dlg
                v-if="modalDiag"
                @close="closeModal"
                :isHour="timeMode"
                :isExpansion="scalMode"
                :isLegend="isLegendDisp"
              ></tm-rain-graph-dlg>
              <div @dblclick="openModal">
                <tm-rain-graph
                  :width="500"
                  :height="250"
                  :isHour="timeMode"
                  :isExpansion="scalMode"
                  :isLegend="isLegendDisp"
                ></tm-rain-graph>
              </div>
            </div>
          </v-col>
          <v-row no-gutters v-if="isDispContentsSwitch()">
            <v-col :md="4">
              <tm-sns class="float-right pt-2 pr-6"></tm-sns>
            </v-col>
            <v-col :md="8" class="pa-2">
              <div class="float-right pt-1">
                <v-btn
                  tile
                  depressed
                  small
                  class="graph-btn"
                  color="success"
                  :outlined="scalMode === true"
                  @click="scalMode = false"
                  >{{ text.btn.zoomout }}</v-btn
                >
                <v-btn
                  tile
                  depressed
                  small
                  class="graph-btn"
                  color="success"
                  :outlined="scalMode === false"
                  @click="scalMode = true"
                  >{{ text.btn.zoomin }}</v-btn
                >
                <v-btn
                  tile
                  depressed
                  small
                  class="graph-btn ml-2"
                  color="success"
                  :outlined="timeMode === false"
                  @click="timeMode = true"
                  >{{ text.btn.timehour }}</v-btn
                >
                <v-btn
                  tile
                  depressed
                  small
                  class="graph-btn"
                  color="success"
                  :outlined="timeMode === true"
                  @click="timeMode = false"
                  >{{ text.btn.time10 }}</v-btn
                >
                <v-btn
                  depressed
                  small
                  class="legend-btn"
                  color="orange"
                  dark
                  :outlined="!isLegendDisp"
                  @click="isLegendDisp = !isLegendDisp"
                >
                  <v-icon>import_contacts</v-icon>
                  {{ text.btn.legend }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
      <tm-rain-curt></tm-rain-curt>
    </template>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]雨量 フレーム
 * TmRainFrame.vue
 * @author LIS
 */

import TmRainInfo from "./TmRainInfo.vue";
import TmRainCurt from "./TmRainCurt.vue";
import TmRainGraph from "./TmRainGraph.vue";
import TmRainGraphDlg from "./TmRainGraphDlg.vue";
import TmSns from "./TmSns";
import PageLog from "./../../lib/pageLog.js";
import mixin from "./../../lib/mixin.js";

export default {
  components: {
    TmRainInfo,
    TmRainCurt,
    TmRainGraph,
    TmRainGraphDlg,
    TmSns,
  },
  mixins: [mixin],
  data() {
    return {
      /** 観測詳細タブ */
      tabIndex: 0,
      /** 文字列リソース */
      text: {
        title_curt: "最新観測値",
        tab: {
          graph: "雨量グラフ",
          obsInfo: "詳細情報",
        },
        btn: {
          zoomout: "全体",
          zoomin: "拡大",
          timehour: "時間毎",
          time10: "10分毎",
          legend: "凡例",
        },
      },
      modalDiag: false,
    };
  },
  created: function () {
    this.loadTmObs();
  },
  beforeDestroy() {
    // アクセスログ用パラメータ破棄
    this.$store.commit("Telemeter/setPageLogParam", null);
  },
  computed: {
    // リクエストパラメータ
    reqParam: {
      get() {
        return this.$store.state.Telemeter.selectedTmParam;
      },
    },
    /** 対象日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /** 観測日時(ファイル取得用) */
    appTimeRound: {
      get() {
        return this.$store.state.app.appTimeRound;
      },
    },
    // 雨量取得
    tmRainList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    // 拡縮表示設定 取得
    scalMode: {
      get() {
        return this.$store.state.Telemeter.scalMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalMode", val);
      },
    },
    // 表示時刻設定 取得
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setTimeMode", val);
      },
    },
    // 凡例表示状態 取得
    isLegendDisp: {
      get() {
        return this.$store.state.Telemeter.isLegendDisp;
      },
      set(val) {
        this.$store.commit("Telemeter/setLegendDisp", val);
      },
    },
    /* フレームの拡大・縮小判定用 */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /*フレーム拡大時のclass設定*/
    pcPanelModeClass: {
      get() {
        if (this.$store.state.app.pcPanelMode) {
          return "tm-pc-frame-content not-overflow";
        } else {
          return "tm-pc-frame-content";
        }
      },
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam: {
      get() {
        if (
          this.$store.state.Telemeter.pageLogParam &&
          this.$store.state.Telemeter.pageLogParam.obsData
        ) {
          return {
            prefCd:
              this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.prefCd,
            twnCd:
              this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.twnCd,
            rvrCd:
              this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.rvrCd,
            obsCd: this.$store.state.Telemeter.pageLogParam.payload.obsFcd,
            appTime: this.$store.state.Telemeter.pageLogParam.payload.appTime,
          };
        }
        return null;
      },
    },
  },
  methods: {
    openModal() {
      this.modalDiag = true;
    },
    closeModal() {
      this.modalDiag = false;
    },
    // 雨量を取得
    getTmRainDatas() {
      setTimeout(() => {
        this.$store.dispatch("Telemeter/getSelectedTm", {
          ofcCd: this.reqParam.ofcCd,
          itmkndCd: this.reqParam.itmkndCd,
          obsCd: this.reqParam.obsCd,
          appTime: this.appTime,
          appTimeRound: this.appTimeRound,
        });
      }, 500);
    },
    /**
     * 表示切替ボタン制御
     */
    isDispContentsSwitch() {
      if (
        this.tmRainList.length !== 0 &&
        (this.tmRainList.graph.hour.value.length > 0 ||
          this.tmRainList.graph.min10.value.length > 0)
      ) {
        return true;
      }
      return false;
    },
    /**
     * 画面更新処理
     */
    loadTmObs() {
      // 選択中テレメータ情報クリア
      this.$store.commit("Telemeter/setSelectedTm", []);
      // グラフ状態クリア
      this.$store.commit("Telemeter/resetTmObs");
      // お知らせ・河川予警報ダイアログ非表示
      this.$store.commit("map/hideInfoRw");
      this.getTmRainDatas();
    },
    // URLパラメータチェック
    checkUrlParam(to, from) {
      if (
        from.query.fld !== to.query.fld ||
        from.query.ofcCd !== to.query.ofcCd ||
        from.query.itmkndCd !== to.query.itmkndCd ||
        from.query.obsCd !== to.query.obsCd
      ) {
        return true;
      }
      return false;
    },
    /** 同タブ内で観測所詳細画面に遷移 */
    openObs() {
      // アクセスログ出力
      PageLog.log({
        page_log: "rain_detail",
        pref_cd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.prefCd,
        twn_cd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.twnCd,
        rvr_cd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo.rvrCd,
        obs_cd: this.$store.state.Telemeter.pageLogParam.payload.obsFcd,
        device_sb: "pc",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.routerPushPcFullTm("/pcfull/tm");
    },
  },
  watch: {
    // 観測日時を監視
    appTimeRound() {
      this.loadTmObs();
    },
    // 観測所遷移 監視
    $route(to, from) {
      if (this.checkUrlParam(to, from)) {
        this.loadTmObs();
      }
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam(to, from) {
      if (
        to &&
        (!from || to.obsCd != from.obsCd || to.appTime != from.appTime)
      ) {
        // アクセスログ出力
        PageLog.log({
          page_log: "rain",
          pref_cd: to.prefCd,
          twn_cd: to.twnCd,
          rvr_cd: to.rvrCd,
          obs_cd: to.obsCd,
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
